// extracted by mini-css-extract-plugin
export default {"root":"error_root__IEvET","label":"error_label__z1XiY","title":"error_title__F76H-","description":"error_description__CseMf","logo":"error_logo__yZONQ"};